export const NavLinks = [
    {
        id: 'home',
        title: 'Home',
    },
    {
        id: 'skills',
        title: 'Skills',
    },
    {
        id: 'experience',
        title: 'Experience',
    },
    {
        id: 'projects',
        title: 'Projects',
    },
    {
        id: 'contact',
        title: 'Contact',
    }
]

export const Description = `I'm a passionate software engineer with a focus on utilizing my technical abilities
          to build user-friendly and intuitive applications, solve complex problems, and 
          work on projects that inspire me. I'm always eager to learn new concepts, 
          pick up new skills, and apply my knowledge in transformative ways. My goal is to craft
          meaningful experiences through code.`

export const Name = "Aayush"

export const Projects = [
  {
    title: "Drop-in Sports Finder",
    description:
      "A cross-platform React Native app to find and join local sports sessions based on skill level.",
    github: "https://github.com/your-profile/drop-in-sports-finder",
    tools: ["React Native", "Expo", "Typescript", "Firebase"],
  },
  {
    title: "Online Blackjack Game",
    description: "An Android app to play Blackjack with a realistic gameplay experience and user-friendly interface.",
    github: "https://github.com/akregmi/blackjack",
    tools: ["Android Studio", "Java", "Firebase", "RoomDB"],
  },
  {
    title: "Portfolio Website",
    description: "A modern portfolio showcasing my projects and skills.",
    github: "https://github.com/akregmi/porfolio",
    tools: ["React","Javascript", "TailwindCSS", "Github Actions"],
  },
  {
    title: "Bank Marketing Classification",
    description:
      "Trained and analyzed a K-Means machine learning model to determine the liklihood of a customer subscribing to a newletter.",
    github: "https://github.com/akregmi/Bank-Marketing-Classification",
    tools: ["Machine Learning", "K-Means Clustering", "Python", "Scikit-Learn", "Pandas"],
  },
  {
    title: "Handwriting Identification",
    description:
      "A script that uses neural networks to identify hand-written numeric digits.",
    github: "https://github.com/akregmi/Handwriting-Recognition",
    tools: ["Machine Learning", "Neural Networks", "Python", "Tensorflow", "Numpy"],
  },
  {
    title: "User API Setup",
    description:
      "Created a reusable microservice to quickly create an API endpoint to store and retrieve users. Detailed documentation is provided.",
    github: "https://github.com/akregmi/thinkon_api",
    tools: ["Java", "Springboot", "REST APIs"],
  },
]

export const Experience = [
  {
    title: "Software Engineer",
    company: "BMO Financial Group",
    duration: "2025 - Present",
    description:
      "Currently working as a developer for the Canadian Business Banking team at BMO.",
    tools: ["Angular", "Typescript", "Python"],
  },
  {
    title: "Software Engineer",
    company: "Investfly",
    duration: "2023 - 2024",
    description:
      "Helped develop a web-based stock trading application allowing users to view trends, optimize trading strategies, and execute trades in real time.",
    tools: ["React", "Spring", "PostgreSQL", "Python", "AWS", "Jenkins CI/CD"],
  },
  {
    title: "iOS Developer Intern",
    company: "Toronto Metrpolitan University",
    duration: "Summer 2022",
    description:
      "Built a comprehensive rewards system app for iOS to improve user retention and loyalty.",
    tools: ["XCode", "Swift", "Firebase", "MongoDB", "Model-View-Viewmodel (MVVM)"],
  },
  {
    title: "Software Engineer Intern",
    company: "BMO Financial Group",
    duration: "Fall 2021 - Winter 2022",
    description:
      "Designed and tested REST APIs, automated and optimized key processes, and updated web pages.",
    tools: ["Angular", "Java", "Springboot", "Postman", "Aspose"],
  },
  {
    title: "Software Engineer Intern",
    company: "Verdure Digital",
    duration: "Summer 2021",
    description:
      "Set up servers to run custom scripts and allow Shopify storefronts to pull up-to-date inventory data",
    tools: ["Python", "GCP", "Selenium", "Shopify"],
  },
  {
    title: "BSc. Computer Science and Mathematics (Hons.)",
    company: "Toronto Metropolitan University",
    duration: "2018 - 2022",
    description:
      "Completed my undergraduate studies in Computer Science and Mathematics with a 3.7 GPA.",
    tools: ["Object Oriented Programming", "Data Structures", "Algorithms", "AI/ML", "Networks", "Computer Security", "Statistics"],
  },
];

export const Skills = [
  {
    category: "Front-End Development",
    items: ["React", 'Angular', "JavaScript", "TailwindCSS", "HTML5", "CSS3"]
  },
  {
    category: "Back-End Development",
    items: ["Node.js", "Express.js", "Spring Boot", "Laravel", "SQL"]
  },
  {
    category: "Database Systems",
    items: ["mySQL", "PostgreSQL", "MongoDB", "Google Firebase", "Amazon RDS"]
  },
  {
    category: "Mobile Development",
    items: ["React Native", "Android Studio", "XCode", "Swift", "Typescript", "Java", "Google Firebase"]
  },
  {
    category: "Cloud Development",
    items: ["Amazon Web Services (AWS)", "Google Cloud Platform (GCP)", "Github Actions", "Jenkins"]
  },
  {
    category: "Data Analysis",
    items: ["Python", "R", "Matlab", "Excel", "Numpy", "Pandas", "Scikit-Learn", "Tensorflow"]
  }
];